import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const InvoiceIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsxs(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Invoice",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M25.67 2H6.33C4.47 2 2.96 3.51 2.96 5.37v21.25c0 1.86 1.51 3.37 3.37 3.37h19.34c1.86 0 3.37-1.51 3.37-3.37V5.37c0-1.86-1.51-3.37-3.37-3.37m1.69 24.63c0 .93-.75 1.69-1.69 1.69H6.33c-.93 0-1.69-.75-1.69-1.69V5.37c0-.93.75-1.69 1.69-1.69h19.34c.93 0 1.69.75 1.69 1.69v21.25Z"
    }), /*#__PURE__*/_jsx("path", {
      d: "M24.7 25.13h-5.97c-.4 0-.74.34-.74.74s.34.74.74.74h5.97c.4 0 .74-.34.74-.74s-.34-.74-.74-.74M7.3 7.52h10.75c.4 0 .74-.34.74-.74s-.34-.74-.74-.74H7.3c-.4 0-.74.34-.74.74s.34.74.74.74M25.35 22.77V10.02c0-.36-.29-.66-.65-.66H7.3c-.36 0-.65.3-.65.66v12.75s.02.17.04.21c.08.27.32.45.61.45h17.41c.36 0 .65-.3.65-.66Zm-6.73-.65H7.96v-3.1h10.67v3.1Zm0-4.41H7.96v-2.86h10.67v2.86Zm0-4.17H7.96v-2.87h10.67v2.87Zm5.41 8.58h-4.1v-3.1h4.1zm0-4.41h-4.1v-2.86h4.1zm0-4.17h-4.1v-2.87h4.1z"
    })]
  }));
};